import React from 'react';
import { Pill } from '../NotionUI';
import { optionColor } from '../ProjectCell';
import { fmtDateDMY } from '../../utils/format';

const SKIPPED = ['title', 'created_time', 'updated_time', 'created_by', 'updated_by'];

const userName = (users, id) => {
  const u = users.find((x) => x.id === id);
  return u ? [u.name, u.surname].filter(Boolean).join(' ') : '';
};

/**
 * Valori secondari di un'attività come piccoli elementi (pillole, date, nomi):
 * per le card della board, le righe della lista e le schede della galleria.
 * Si saltano le celle vuote, il titolo e le colonne in `exclude`.
 */
export default function taskValues(task, columns, { users, allTasks = [], exclude = [], max = 4 }) {
  return columns
    .filter((c) => !SKIPPED.includes(c.type) && !exclude.includes(c.id) && task.data[String(c.id)] !== undefined)
    .slice(0, max)
    .map((c) => {
      const value = task.data[String(c.id)];
      if (c.type === 'select' || c.type === 'status') {
        const option = c.options.find((o) => o.value === value);
        return option ? <Pill key={c.id} color={optionColor(option)}>{option.label}</Pill> : null;
      }
      if (c.type === 'multi_select') {
        return (Array.isArray(value) ? value : []).map((v) => {
          const option = c.options.find((o) => o.value === v);
          return option ? <Pill key={`${c.id}:${v}`} color={optionColor(option)}>{option.label}</Pill> : null;
        });
      }
      if (c.type === 'daterange') return <span key={c.id} className="nt-muted pd-card-value">{[value.start, value.end].filter(Boolean).map(fmtDateDMY).join(' → ')}</span>;
      if (c.type === 'files') return <span key={c.id} className="nt-muted pd-card-value">📎 {value.length}</span>;
      if (c.type === 'task_relation') {
        const titles = (Array.isArray(value) ? value : []).map((id) => allTasks.find((x) => x.id === id)?.title).filter(Boolean);
        return titles.length > 0 ? <span key={c.id} className="nt-muted pd-card-value" title={titles.join(', ')}>🔗 {titles.length}</span> : null;
      }
      let text = String(value);
      if (c.type === 'date') text = fmtDateDMY(value);
      else if (c.type === 'person') text = (Array.isArray(value) ? value : [value]).map((id) => userName(users, id)).filter(Boolean).join(', ');
      else if (c.type === 'checkbox') text = `✓ ${c.name}`;
      return text ? <span key={c.id} className="nt-muted pd-card-value">{text}</span> : null;
    });
}
